/* 2026-10-01: allowlist expansion and official route measurement.
   One persuasion lever: concrete recipe contents. Position, book and other CTAs unchanged. */
(function () {
  'use strict';
  var EXP = 'line_recipe_value_20260930';
  var KEY = 'nuchi_line_recipe_value_20260930';
  var COPY = {
    'mozuku-tabekata': 'もずく料理に、もう一品。塩こうじで作る副菜を手元に。',
    'shiokoji-kogeru-yakikata': '焼く料理だけでなく、和える・漬ける使い方も。',
    'shiokoji-tsukaikata-guide': '「次は何に使おう？」に、30品の選択肢を。',
    'shiokoji-osaji1-nan-gram': '分量を確かめたら、次は使いたい一品を。',
    'shiokoji-hozon': '保存方法とあわせて、使い道も増やしておきませんか。'
  };

  var BOOKS = {"mozuku-tabekata": "shiokoji", "shiokoji-kogeru-yakikata": "shiokoji", "shiokoji-tsukaikata-guide": "shiokoji", "shiokoji-osaji1-nan-gram": "shiokoji", "shiokoji-hozon": "shiokoji", "guava-tabekata-shun": "amakoji", "dragonfruit-tabekata-recipe": "amakoji", "torihamu-hozon": "shiokoji", "amazake-hozon-shomikigen": "amakoji", "shikuwasa-tsukaikata": "amakoji", "amazake-sweets-recipe": "amakoji", "shikuwasa-shun-jiki": "amakoji", "suchka-tsukurikata-shiokoji": "shiokoji", "amakoji-hozon": "amakoji", "amazake-suppai-genin": "amakoji", "shima-banana-tsuijuku": "amakoji", "amazake-amakoji-chigai": "amakoji", "shiokoji-shihan-erabikata": "shiokoji", "shiokoji-shoppai-naoshikata": "shiokoji", "amazake-hozon": "amakoji", "shikuwasa-aogiri-kanjuku-chigai": "amakoji", "okinawa-fruits-shun-calendar": "amakoji", "dragonfruit-erabikata": "amakoji", "amazake-usumeru": "amakoji", "shiokoji-erabikata": "shiokoji", "amazake-tsubutsubu": "amakoji", "amakoji-tsukaikata": "amakoji"};
  var ROUTES = {control: "https://lin.ee/yrgDsJM", specific: "https://lin.ee/5e9ue31"};
  var handle = decodeURIComponent(location.pathname).replace(/\/$/, '').split('/').pop();
  if (!Object.prototype.hasOwnProperty.call(BOOKS, handle)) return;
  var gift = BOOKS[handle];
  var query = new URLSearchParams(location.search);
  var qa = query.get('nuchi_qa') === 'line_value';
  var forced = qa ? query.get('line_value_arm') : null;
  var started = false, attempts = 0, withdrawn = false;

  function allowed() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
  }
  function emit(stage, arm) {
    var meter = window.nuchiFunnelV2;
    if (withdrawn || !allowed() || !meter || !meter.emit) return false;
    return meter.emit('nuchi_line_value_' + stage, {
      experiment_id: EXP + '_' + arm, experiment_variant: arm,
      article_handle: handle, gift: gift, placement: 'inbody',
      measurement_version: 'line_value_50pct_1sec_v1'
    });
  }
  function assign() {
    if (forced === 'specific' || forced === 'control') return forced;
    if (!allowed()) return null;
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved && saved.expires > Date.now() && /^(control|specific)$/.test(saved.arm)) return saved.arm;
      var arm = Math.random() < 0.5 ? 'control' : 'specific';
      localStorage.setItem(KEY, JSON.stringify({arm: arm, expires: Date.now() + 28 * 86400000}));
      return arm;
    } catch (e) { return null; }
  }
  function start() {
    if (started) return;
    var card = document.getElementById('nuchi-line-recipe-inline');
    var meter = window.nuchiFunnelV2;
    if (!card || !meter) {
      if (++attempts < 40) setTimeout(start, 250);
      return;
    }
    // Fail closed if another editor changes the selected book or component.
    if (card.dataset.lineGift !== gift || card.dataset.lineValueExperiment) return;
    var hook = card.querySelector('.nli-hook');
    var desc = card.querySelector('.nli-desc');
    var button = card.querySelector('.nli-button');
    var cover = card.querySelector('.nli-cover');
    if (!hook || !desc || !button || !cover ||
        button.getAttribute('href') !== 'https://lin.ee/AvHTNTo' ||
        !(new RegExp('/cover_' + gift + '\\.jpg(?:\\?.*)?$')).test(cover.getAttribute('src') || '')) return;
    // The book does not contain this article's mozuku dish. Never retain the
    // old implication that it is this recipe plus 29 others, in either arm.
    if (/ほかの29品|あと29品/.test(hook.textContent)) hook.textContent = '次の献立にも役立つレシピを。';
    // Shopify may load its privacy API after the page's deferred scripts.
    // Wait for availability; never interpret an absent API as consent.
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!(forced === 'specific' || forced === 'control') &&
        (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function')) {
      card.dataset.lineValueStatus = 'waiting_for_privacy_api';
      if (++attempts < 60) setTimeout(start, 250);
      return;
    }
    var arm = assign();
    if (!arm) { card.dataset.lineValueStatus = 'unassigned_no_consent_or_storage'; return; }
    started = true;
    var original = {hook: hook.textContent, desc: desc.textContent, href: button.getAttribute('href')};
    button.setAttribute('href', ROUTES[arm]);
    card.dataset.lineValueEpoch = '20261001_expanded_routes';
    card.dataset.lineValueExperiment = EXP;
    card.dataset.lineValueArm = arm;
    card.dataset.lineValueStatus = 'ready';
    if (arm === 'specific') {
      hook.textContent = COPY[handle] || (gift === 'amakoji' ? '甘こうじは、飲むだけでなく料理にも。' : '次に作りたい一品を、手元に。');
      desc.textContent = gift === 'amakoji' ? '例えば「れんこんの糀甘酢漬け」「豚こまと玉ねぎの甘糀しょうゆ豚丼」「鶏ももの甘糀てり焼き」。甘こうじを使う15品を、材料・手順つきでまとめました。' : '例えば「塩こうじの冷ややっこ」「きゅうりと大根の塩こうじ浅漬け」「塩こうじの無限ピーマンナムル」。沖縄・那覇の仲宗根糀家が選んだ30品を、材料・手順つきでまとめました。';
    }
    var assignedSent = emit('eligible', arm), seen = false, inside = false, timer;
    function check() {
      clearTimeout(timer);
      if (!allowed()) return;
      if (!assignedSent) assignedSent = emit('eligible', arm);
      if (seen || !inside || document.visibilityState !== 'visible') return;
      timer = setTimeout(function () {
        if (!seen && inside && document.visibilityState === 'visible' && allowed()) seen = emit('visible', arm);
      }, 1000);
    }
    var observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        inside = entries.some(function (e) { return e.target === card && e.isIntersecting && e.intersectionRatio >= 0.5; });
        check();
      }, {threshold: [0, 0.5]});
      observer.observe(card);
    }
    button.addEventListener('click', function () { emit('click', arm); });
    document.addEventListener('visibilitychange', check);
    document.addEventListener('visitorConsentCollected', function () {
      if (!allowed()) {
        withdrawn = true;
        clearTimeout(timer);
        // No experimental storage or copy after analytics consent is withdrawn.
        try { localStorage.removeItem(KEY); } catch (e) {}
        hook.textContent = original.hook; desc.textContent = original.desc;
        button.setAttribute('href', original.href);
        card.dataset.lineValueStatus = 'consent_withdrawn';
        if (observer) observer.disconnect();
        inside = false;
        return;
      }
      check();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('visitorConsentCollected', start);
})();
